/* eslint-disable no-underscore-dangle */
import React from 'react';

import { DsTypography } from 'componentsV2/DS';
import expiredLinkIllustration from 'modules/custom-payment-link/assets/link-state-expired.png';

import {
  Content,
  ImageBox,
  TextBox,
  TitleBox,
  SubtitleBox,
  Wrapper,
} from './styles';

const ExpiredLink: React.FC = () => {
  return (
    <Wrapper>
      <Content>
        <ImageBox>
          <img
            src={expiredLinkIllustration.src}
            alt="Ilustração informando que o link de pagamento expirou"
            width={500}
            height={397}
          />
        </ImageBox>
        <TextBox>
          <DsTypography
            component="heading"
            size="x-large"
            color="neutral-medium"
          >
            Link expirado
          </DsTypography>
          <TitleBox>
            <DsTypography component="paragraph" size="x-large">
              Esse link não é mais válido. Ele pode ter expirado ou já ter sido
              utilizado.
            </DsTypography>
          </TitleBox>
          <SubtitleBox>
            <DsTypography component="paragraph" size="medium">
              Entre em contato com o(a) vendedor(a) para solicitar um novo link.
            </DsTypography>
          </SubtitleBox>
        </TextBox>
      </Content>
    </Wrapper>
  );
};

export default ExpiredLink;
